const PLACE_A_PERSON_OPENED = 'Place a Person - Opened';
const PLACE_A_PERSON_FILTERS_USED = 'Place a Person - Filters Used';
const PAYLOAD_DISTANCE_FROM_PROJECT = 'Distance from project';

export {
  PLACE_A_PERSON_OPENED,
  PLACE_A_PERSON_FILTERS_USED,
  PAYLOAD_DISTANCE_FROM_PROJECT,
};
